import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LangEnum from '../../../../../lang/LangEnum';
import PATHS from '../../../../../routes/routes.const';
import snackbarStore from '../../../../../stores/Snackbar.store';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../translation/TranslationContext';

const useNotFoundPage = () => {
  const { brandSlug } = useApplicationContext();
  const location = useLocation();
  const history = useHistory();
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  useEffect(() => {
    if (brandSlug && !location.pathname.includes(brandSlug)) {
      handleMessage({
        type: 'error',
        message: translate(LangEnum.INVALID_CONTEXT_LINK),
      });
    }
  }, []);

  const goToHome = () => {
    history.push(PATHS.main.home.path);
  };

  return { goToHome };
};

export default useNotFoundPage;
